

import Vue from 'vue'
import Tab from 'vux/src/components/tab/tab.vue'
import Cell from 'vux/src/components/cell/index.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Group from 'vux/src/components/group/index.vue'



export default {
components: {
Tab,
TabItem,
Cell,
Group
},
data (){
return{
companys:[],
model:{}
}

},
created(){
this.getSubordinateCompany();
},




methods: {
goBack(){
this.$router.push({
path : '/user/index',
query : {}
})
},
getSubordinateCompany(){
let that =this;
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getSubordinateCompany',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
that.companys=res.body.companyList;
}
},function(res){
console.log(res.status);
});
}
}
}



// WEBPACK FOOTER //
// ./src/views/user/subordinateCompany.vue